import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitPrescriptionService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'temr_visit_prescription/list/?';
    private AddRecordList = webapi + 'temr_visit_prescription/createlist';
    private EditRecord = webapi + 'temr_visit_prescription/update';
    private GetRecord = webapi + 'temr_visit_prescription/byid/';
    private DeleteRecord = webapi + 'temr_visit_prescription/delete/';
    private GetPrescriptionByVisitId = webapi + 'temr_visit_prescription/byvisitid/';
    private GetPrescriptionByTimelineId = webapi + 'temr_visit_prescription/bytimelineid/';
    private GetPrescriptionByAdmissionIdNew = webapi + 'temr_visit_prescription/byAdmissionIdNew/';
    private GetPrescriptionByAdmissionId = webapi + 'temr_visit_prescription/byAdmissionId/';
    private AddRecord = webapi + 'temr_visit_prescription/create';
    private VisitByMrno = webapi + 'temr_visit_prescription/bymrno';
    private GetPrescriptionByVisitIdPage = webapi + 'temr_visit_prescription/listByVisitIdPage/?';
    private AddDruges = webapi + 'temr_item_prescription/create';
    private DeleteItem = webapi + 'temr_item_prescription/delete/';
    private fetchItem = webapi + 'temr_visit_prescription/bytimelineId/';
    private VisitByMrnoForClosePre = webapi + 'temr_visit_prescription/bymrnoforClosePre';
    // private GetPrescriptionByAdmisionId = webapi + 'temr_visit_prescription/byAdmisionId/';
    private GetPrescriptionByVisitIdBYDTO = webapi + 'temr_visit_prescription/byvisitidByDto/';
    private DeleteDruges = webapi + 'temr_item_prescription/delete/';
    private GetPatientListByStore = webapi + 'temr_visit_prescription/patient-list?storeId=';
    

    constructor(private http: Http) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPrescriptionByVisitIdPageRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetPrescriptionByVisitIdPage + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordListService(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.AddRecordList, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


  deleteItemService(id: any) {
      const url = `${this.DeleteItem}${id}`; // Ensure correct URL formation
      return this.http.put(url, {}, {headers: this.headers})
      // return this.http.put(this.DeleteItem + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPrescriptionByVisitId(visitId: any) {
        return this.http.get(this.GetPrescriptionByVisitId + visitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPrescriptionByVisitIdByDTO(vpId: any) {
        return this.http.get(this.GetPrescriptionByVisitIdBYDTO + vpId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPrescriptionByTimelineId(timelineId: any) {
        return this.http.get(this.GetPrescriptionByTimelineId + timelineId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    fetchPrescriptionByTimelineId(timelineId: any) {
        return this.http.get(this.fetchItem + timelineId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPrescriptionByAdmissionId(admissionId: any) {
        return this.http.get(this.GetPrescriptionByAdmissionId + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getPrescriptionByAdmissionIdNew(admissionId: any) {
        return this.http.get(this.GetPrescriptionByAdmissionIdNew + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getVisitByMRno(model: any) {
        return this.http.put(this.VisitByMrno, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getVisitByMRnoForClosePre(model: any) {
        return this.http.put(this.VisitByMrnoForClosePre, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addDrugeList(model: any) {
        return this.http.post(this.AddDruges, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    /* getVisitByMRnoByObject(id: any) {
       let obj: any = {};
       obj.vpPatientMrNumber = id;
       return this.http.put(this.VisitByMrno, JSON.stringify(obj), {headers: this.headers})
         .toPromise()
         .then(response => response.json())
         .catch(this.handleError);

     }
   */

    deleteItemRecordService(id: any) {
        return this.http.put(this.DeleteDruges + id, {},  {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

getPatientListByStore(storeId: any): Promise<any> {
    return this.http.get(this.GetPatientListByStore + storeId)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
}
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-prescription/temr-visit-prescription.service.ts